/**
 * All the routes
 */
export const routes = {
	login: "auth/login",
	signup: "auth/signup",
    firebaseLogin: "auth/firebase-login",
	logout: "auth/logout",
	cartItems: "/cart/items",
	cartSync: "/cart/sync",
	customerProducts: "/customers/products",
	deliveryAddress: "/delivery-addresses",
	orders: "/orders",
	orderItems: "/order-items",
	pendingBusinessRatings: "/orders/pending-business-ratings",
	payments: "/payments",
	users: "/users",
	userStats: "/users/stats",
	paymentRequests: "/payment-requests",
	reviews: "/reviews",
	capaPurchases: "/capa-purchases",
	aiCreditPurchases: "/ai-credit-purchases",
	voiceOrderSessions: "/ai/voice-orders/sessions",
	orderPaymentSurpluses: "/order-payment-surpluses",
	settings: "/user-settings",
	awards: "/awards",
	transfers: "/transfers",
	follows: "/follows",
	businesses: "/companies",
	comments: "/comments",
	mentions: "/mentions",
	deliverers: "/deliverers",
	errands: "/errands",
	subscriptions: "/subscriptions",
	companyBookmarks: "/company-bookmarks",
	featureAnnouncements: "/feature-announcements",
};